import React, { useState, useCallback } from 'react';

import {kanbanData, kanbanGrid} from './data';
import {Header} from '../../components';

export const Kanban = () => {
  const [items, setItems] = useState(() => kanbanData.slice());

  const onDragStart = useCallback((e: React.DragEvent, id: string) => {
    e.dataTransfer.setData('text/plain', id);
    e.dataTransfer.effectAllowed = 'move';
  }, []);

  const onDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  }, []);

  const onDrop = useCallback((e: React.DragEvent, status: string) => {
    e.preventDefault();
    const id = e.dataTransfer.getData('text/plain');
    setItems(prev => prev.map(it => (it.Id === id ? {...it, Status: status} : it)));
  }, []);

  const grouped = kanbanGrid.map(col => ({...col, cards: items.filter(i => i.Status === col.keyField)}));

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white dark:bg-secondary-dark-bg dark:text-gray-200 rounded-3xl">
      <Header category="Aplicativo" title="Kanban"/>
      <div className="flex gap-4">
        {grouped.map((col) => (
          <div key={col.keyField} className="flex-1 bg-gray-50 dark:bg-secondary-dark-bg rounded p-4" onDragOver={onDragOver} onDrop={(e) => onDrop(e, col.keyField)}>
            <h3 className="font-semibold mb-3">{col.headerText}</h3>
            <div className="space-y-3">
              {col.cards.map((card: any) => (
                <div
                  key={card.Id}
                  draggable
                  onDragStart={(e) => onDragStart(e, card.Id)}
                  className="p-3 bg-white dark:bg-secondary-dark-bg rounded shadow-sm cursor-grab"
                >
                  <div className="text-sm font-medium">{card.Id}</div>
                  <div className="text-xs text-gray-600 dark:text-gray-300">{card.Summary}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
